import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import changePhoneNumberSlice from './changePhoneNumberSlice';

export default class ChangePhoneNumberInitializableModule implements IInitializableModule {
  protected name: string = 'Change Phone Number';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    // Configure any service dependencies here if needed
  }

  public StartModule(context: IEpiserverContext): void {
    // Initialize any module-specific logic here if needed
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'changePhoneNumber',
      reducer: changePhoneNumberSlice,
    };
    return null;
  }
}
